import { j as json } from "../../../../../../chunks/index2.js";
import { h as handleRequest } from "../../../../../../chunks/utils.js";
import admin from "firebase-admin";
const ensureUserId = async () => {
  const userCollection = admin.firestore().collection("users");
  const users = await userCollection.get();
  for (const userDoc of users.docs) {
    const user = userDoc.data();
    if (userDoc.id.includes("@glimmr.com")) {
      await userDoc.ref.delete();
      await userCollection.doc(user.id).set(user);
    }
  }
};
const GET = handleRequest(async () => {
  await ensureUserId();
  return json({
    success: true
  });
});
export {
  GET
};
